import { Fab } from '@mui/material';
import { CREATE_EVENT_ROUTE } from '../constants';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { usePadding } from '../spacing';
import { usePermissions } from '../hooks/usePermissions';

export default function CreateFab() {
    const navigate = useNavigate();
    const { bottomPadding } = usePadding();
    const { canEditEvents } = usePermissions();

    if (!canEditEvents) {
        return null;
    }

    return (
        <Fab
            color="primary"
            aria-label="create"
            sx={{
                position: 'fixed',
                bottom: bottomPadding + 32,
                right: 32,
            }}
            onClick={() => navigate(CREATE_EVENT_ROUTE)}
        >
            <AddIcon />
        </Fab>
    );
}
